import styled, { AnyStyledComponent, css } from 'styled-components'
import CloseIcon from '../../../../../assets/icons/filter-icons/close-icon.svg'

export const Container = styled.div(
    ({ theme }) => css`
        height: 3.5rem;
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
        border-bottom: ${theme.typography.border.width.xxxThin} solid #0000001a;
        justify-content: space-between;
        align-items: center;
    `,
)

export const Title = styled.strong(
    ({ theme }) => css`
        flex-grow: 1;
        padding: 0.875rem 0 0.875rem 1.5rem;
        letter-spacing: -0.021875rem;
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.large} / 1.75rem
            ${theme.typography.font.family.latoVerdana};
    `,
)

export const CloseIconContainer = styled.span(
    ({ theme }) => css`
        padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium} 0;
        text-align: right;
        color: ${theme.colors.tfwBlack99};
        cursor: pointer;
        font-weight: 400;
        font-size: 0.875rem;
        font-family: ${theme.typography.font.family.latoVerdana};
    `,
)

export const StyledCloseIcon = styled(CloseIcon as AnyStyledComponent)`
    width: 3.5rem;
    height: 3.25rem;
    padding: 1.125rem 0.785rem 0.625rem 1.125rem;
    cursor: pointer;
`
